export interface SocialWidgetService {
    title: string;
    name: string;
    icon: string;
    type: string;
    placeholder: string;
    inputType?: string;
    pattern?: string;
}

export const SOCIALS_WIDGET_SERVICES: SocialWidgetService[] = [
    {
        title: 'x',
        name: 'x Url',
        icon: 'twitter',
        type: 'twitter',
        placeholder: 'https://www.x.com/username',
        pattern: 'https?://((www|\w\w)\.)?x.com/[a-zA-Z0-9._]+$',
    },
    {
        title: 'Threads',
        name: 'Threads',
        icon: 'threads',
        type: 'threads',
        placeholder: 'https://www.threads.net/@username',
        inputType: 'url',
        pattern: 'https://www.threads.net/@[a-zA-Z0-9._]+$',
    },
    {
        title: 'Instagram',
        name: 'Instagram Url',
        icon: 'instagram',
        type: 'instagram',
        placeholder: 'https://www.instagram.com/username',
        pattern: 'https?://((www|\w\w)\.)?instagram.com/[a-zA-Z0-9._]+$',
    },
    {
        title: 'LinkedIn Company',
        name: 'LinkedIn Company Name',
        icon: 'linkedin',
        type: 'linkedin_official',
        placeholder: 'https://linkedin.com/company/companyname',
        inputType: 'url',
        pattern: 'https?://((www|\w\w)\.)?linkedin.com/((company/[^/]+/?)|(pub/[^/]+/((\w|\d)+/?){3}))+$',
    },
    {
        title: 'LinkedIn Profile',
        name: 'LinkedIn Profile',
        icon: 'linkedin-profile',
        type: 'linkedin',
        placeholder: 'https://linkedin.com/in/username',
        inputType: 'url',
        pattern: 'https?://((www|\w\w)\.)?linkedin.com/((in/[^/]+/?)|(pub/[^/]+/((\w|\d)+/?){3}))+$',
    },
    {
        title: 'Facebook',
        name: 'Facebook Url',
        icon: 'facebook',
        type: 'facebook',
        placeholder: 'https://www.facebook.com/username',
        pattern: 'https?://((www|\w\w)\.)?facebook.com/[a-zA-Z0-9._]+$',
        inputType: 'url',
    },
    {
        title: 'WhatsApp',
        name: 'WhatsApp Number',
        icon: 'whatsapp',
        type: 'whatsapp',
        placeholder: '+00000000000',
        pattern: '^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]*$',
    },
    {
        title: 'Telegram',
        name: 'Telegram Url',
        icon: 'telegram',
        type: 'telegram',
        placeholder: 'https://t.me/',
        inputType: 'url',
        pattern: 'https?://((www|\w\w)\.)?t.me/[a-zA-Z0-9._]+$',
    },
    {
        title: 'Youtube Channel',
        name: 'Youtube Channel Url',
        icon: 'youtube',
        type: 'subscriptions',
        placeholder: 'https://www.youtube.com/channel/name',
        inputType: 'url',
        pattern: 'https?://((www|\w\w)\.)?youtube.com\/(.+)$',
    },
    {
        title: 'Google Map',
        name: 'Google Map Shareable Url',
        icon: 'google-map',
        type: 'gmap',
        placeholder: 'https://www.goo.gl/maps/dgsycpPZhtuGa5by7',
        inputType: 'url',
        pattern: 'https?://((www|\w\w)\.)?goo.gl/maps/[a-zA-Z0-9._]+$',
    },
    {
        title: 'Email',
        name: 'Email',
        icon: 'mail',
        type: 'mail',
        placeholder: 'your@email.com',
        inputType: 'email',
    },
    // {
    //     name: 'TikTok Username',
    //     type: 'tiktok',
    //     placeholder: '@tiktokusername',
    //     pattern: '^@[a-zA-Z0-9._]+$',
    // },
    // {
    //     name: 'Youtube  Url',
    //     type: 'youtube',
    //     placeholder: 'https://www.youtube.com/@youtubeurl',
    //     inputType: 'url',
    //     pattern: 'https?://((www|\w\w)\.)?youtube.com/@[a-zA-Z0-9._]+$',
    // },
    // {
    //     name: 'SoundCloud Url',
    //     type: 'soundcloud',
    //     placeholder: 'https://soundcloud.com/username',
    //     inputType: 'url',
    //     pattern: 'https://soundcloud.com/[a-zA-Z0-9._]+$',
    // },
    // {
    //     name: 'Bandcamp Url',
    //     type: 'bandcamp',
    //     placeholder: 'https://you.bandcamp.com',
    //     inputType: 'url',
    //     pattern: 'https://[a-zA-Z0-9._]+.bandcamp.com$',
    // },
    // {
    //     name: 'Twitch Url',
    //     type: 'twitch',
    //     placeholder: 'https://twitch.tv/username',
    //     inputType: 'url',
    //     pattern: 'https://twitch.tv/[a-zA-Z0-9._]+$',
    // },
    // {
    //     name: 'Patreon Url',
    //     type: 'patreon',
    //     placeholder: 'https://patreon.com/username',
    //     inputType: 'url',
    //     pattern: 'https://patreon.com/[a-zA-Z0-9._]+$',
    // },
    // {
    //     name: 'Pinterest Url',
    //     type: 'pinterest',
    //     placeholder: 'https://in.pinterest.com/',
    //     inputType: 'url',
    //     pattern: 'https?://((www|\w\w)\.)?in.pinterest.com/.+',
    // },
    // {
    //     name: 'Spotify Artist Url',
    //     type: 'spotify',
    //     placeholder: 'https://open.spotify.com/artist/artistname',
    //     inputType: 'url',
    //     pattern: 'https?://((www|\w\w)\.)?open.spotify.com/artist/[a-zA-Z0-9._]+$',
    // },
    // {
    //     name: 'Amazon Shop Url',
    //     type: 'amazon',
    //     placeholder: 'https://amazon.com/shop/yourshopname',
    //     inputType: 'url',
    //     pattern: 'https?://((www|\w\w)\.)?amazon.com/shop/[a-zA-Z0-9._]+$',
    // },
    // {
    //     name: 'Snapchat Url',
    //     type: 'snapchat',
    //     placeholder: 'https://www.snapchat.com/add/yourusername',
    //     inputType: 'url',
    //     pattern: 'https://www.snapchat.com/add/[a-zA-Z0-9._]+$',
    // },
    // {
    //     name: 'Apple Music Url',
    //     type: 'apple',
    //     placeholder: 'https://music.apple.com/us/album/youralbum',
    //     inputType: 'url',
    //     pattern: 'https?://((www|\w\w)\.)?music.apple.com/.+',
    // },
];
